import { Link } from "react-router-dom";
import { ShieldCheck, FlaskConical, Truck, Award, Target } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function About() {
  return (
    <div>
      <section className="relative border-b border-ape-border overflow-hidden">
        <img src={BRAND.workout} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-r from-ape-bg via-ape-bg/85 to-transparent" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-28">
          <span className="font-mono2 text-xs tracking-[0.3em] text-ape-red">OUR STORY</span>
          <h1 className="font-display text-5xl sm:text-7xl tracking-tight mt-3 max-w-3xl">PRIMAL STRENGTH.<br /><span className="text-ape-red">MODERN SCIENCE.</span></h1>
          <p className="text-ape-muted text-lg mt-5 max-w-2xl">APE-TIDES was born from a refusal to settle for average. We exist for the disciplined, the relentless, and the ones committed to evolving beyond their limits — every single day.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <span className="font-mono2 text-xs tracking-[0.3em] text-ape-red">THE SILVERBACK STANDARD</span>
          <h2 className="font-display text-4xl tracking-tight mt-3">STRENGTH. DISCIPLINE. RESILIENCE.</h2>
          <p className="text-ape-muted mt-4 leading-relaxed">The silverback doesn't ask for respect — it earns it through raw power, unwavering discipline, and relentless resolve. That's the standard we hold ourselves to with every batch we produce.</p>
          <p className="text-ape-muted mt-4 leading-relaxed">We source, test, and package the highest-purity research peptides available, so researchers who demand excellence never have to compromise. No shortcuts. No excuses. Only the pursuit of better.</p>
        </div>
        <div className="border border-ape-border overflow-hidden aspect-[4/3]">
          <img src={BRAND.lab} alt="Lab science" className="w-full h-full object-cover" />
        </div>
      </section>

      <section className="bg-ape-surface border-y border-ape-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20">
          <h2 className="font-display text-4xl tracking-tight mb-12 text-center">WHAT WE STAND FOR</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: ShieldCheck, t: "Third-Party Tested", s: "Every batch independently verified for purity and identity." },
              { icon: FlaskConical, t: "99%+ Purity", s: "HPLC and mass-spec validated research compounds." },
              { icon: Truck, t: "Discreet Shipping", s: "Secure, confidential, and fast delivery on every order." },
              { icon: Award, t: "Premium Quality", s: "USA-based, batch-coded, premium lyophilized powder." },
            ].map((c, i) => (
              <div key={i} className="border border-ape-border bg-ape-bg p-6">
                <c.icon className="text-ape-red" size={30} />
                <h3 className="font-display text-2xl tracking-wide mt-4">{c.t}</h3>
                <p className="text-ape-muted text-sm mt-2">{c.s}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-24 text-center">
        <Target className="mx-auto text-ape-red mb-6" size={48} />
        <h2 className="font-display text-4xl sm:text-6xl tracking-tight">BECOME STRONGER<br /><span className="text-ape-red">EVERY SINGLE DAY.</span></h2>
        <p className="text-ape-muted mt-5 max-w-xl mx-auto">Discipline over motivation. Consistency over comfort. The relentless pursuit of excellence never stops. Fuel your drive to evolve beyond limits.</p>
        <Link to="/shop" className="inline-flex mt-8 bg-ape-red hover:bg-ape-redhover text-white font-head uppercase tracking-widest px-8 py-4 transition-colors duration-150" data-testid="about-shop-btn">Shop the Arsenal</Link>
      </section>
    </div>
  );
}
